import * as Tabs from '@wandb/weave/components/Tabs';
import React, {useEffect, useState} from 'react';

import {useDebounceState} from '../../../util/hooks';
import {useStatsigGateMultiMetricQuickAdd} from '../../../util/rampFeatureFlags';
import {MultiMetricPanelAdd} from './MultiMetricPanelAdd';
import {usePanelsQuickAddContext} from './PanelsQuickAddContext';
import {QuickAddHeader} from './QuickAddHeader';
import {SingleKeyPanelAdd} from './SingleKeyPanelAdd';

export const PanelsQuickAdd = () => {
  const isMultiMetricQuickAddEnabled = useStatsigGateMultiMetricQuickAdd();
  const [selectedTab, setSelectedTab] = useState('single-key');

  // single-key panels search term
  const {initialSearchStr} = usePanelsQuickAddContext();
  const [searchStr, dSearchStr, setSearchStr] = useDebounceState(
    initialSearchStr,
    200
  );
  useEffect(
    () => setSearchStr(initialSearchStr),
    [initialSearchStr, setSearchStr]
  );

  // multi-metric panels regex
  const [regex, debouncedRegex, setRegex] = useDebounceState('', 500);

  return (
    <div>
      <QuickAddHeader />
      {!isMultiMetricQuickAddEnabled && (
        <SingleKeyPanelAdd
          searchStr={searchStr}
          dSearchStr={dSearchStr}
          setSearchStr={setSearchStr}
        />
      )}
      {isMultiMetricQuickAddEnabled && (
        <Tabs.Root
          value={selectedTab}
          onValueChange={value => setSelectedTab(value)}>
          <Tabs.List className="mx-24 mt-16">
            <Tabs.Trigger value="single-key">Single-key panels</Tabs.Trigger>
            <Tabs.Trigger value="multi-metric">
              Multi-metric panels
            </Tabs.Trigger>
          </Tabs.List>
          <div>
            <Tabs.Content value="single-key">
              <SingleKeyPanelAdd
                searchStr={searchStr}
                dSearchStr={dSearchStr}
                setSearchStr={setSearchStr}
              />
            </Tabs.Content>
            <Tabs.Content value="multi-metric">
              <MultiMetricPanelAdd
                regex={regex}
                debouncedRegex={debouncedRegex}
                setRegex={setRegex}
              />
            </Tabs.Content>
          </div>
        </Tabs.Root>
      )}
    </div>
  );
};
